import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';

const DesktopHero = ({ sharedWorkout: { user, workout } }) => {
  return (
    <div className="hero-section">
      <div className="scrim" />
      <div
        className="background-image"
        style={ workout.imageUrls && {
          backgroundImage: `url(${ workout.imageUrls.cover })`
        }}
      />
      <div className="copy-container">
        <h1>{ workout.title }</h1>
        { user &&
          <p><I18n desc="Title describing who completed the workout.">Completed by</I18n> { user.fullname }</p>
        }
      </div>
    </div>
  );
};

DesktopHero.propTypes = {
  sharedWorkout: PropTypes.object.isRequired
};

const ConnectedDesktopHero = connect((state) => {
  return {
    sharedWorkout: state.sharedWorkout
  };
})(DesktopHero);

export default ConnectedDesktopHero;